<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['included','excluded'].map(v => {
			return { value: v, label: v.substr(0,1).toUpperCase()+v.substr(1) };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

